import React, {useEffect, useState, useRef  } from "react";
import { Formik, Field, ErrorMessage } from 'formik';
import { Link } from "react-router-dom";

import Schema from './registerValidationSchema';
import { imagePath } from "../../utils/assetUtils";

import { api } from '../../api';
import { toast } from "react-toastify";
import Loader from "../loader/Loader";
import { getBase64 } from '../../utils/converter';

import RegionFormIndia from './RegionFormIndia';
import RegionFormUae from './RegionFormUae';
const LoginImage = imagePath("login-logo.png");



export default function Register(props) {
  const options = [
    { value: 'business', label: 'Business' },
    { value: 'individual', label: 'Individual' }
  ];

const fileInputRefs = useRef([]);
const [documentOptions, setDocumentOptions] = useState([]);

const [regionList, setRegionList] = useState([]);

const [loading, setLoading] = useState(false)
const [isLoad,setLoad] = useState(false)


const [documents, setDocuments] = useState([
  { documentTypeId: '', fileName: null }
]);

const handleAddDocument = () => {
  const hasIncomplete = documents.some(doc => !doc.documentTypeId || !doc.fileName);
  if (hasIncomplete) {
    toast.error('Please complete all existing document entries before adding a new one.');
    return;
  }

  if (documents.length < 5) {
  setDocuments([
    ...documents,
    { documentTypeId: '', fileName: null}
  ]);
  }
};

const handleRemoveDocument = (index) => {
  const updated = documents.filter((_, i) => i !== index);
  setDocuments(updated);
};

const handleDocumentChange = (index, field, value) => {
  
  if (field === 'documentTypeId') {
    const isDuplicate = documents.some((doc, i) => doc.documentTypeId === value && i !== index);
    if (isDuplicate) {
      toast.error('This document type is already selected.');
      return;
    }

  }


  const newDocs = [...documents];

  if (field === 'file') {
    const file = value;

    if (!file) {
    if (fileInputRefs.current[index]) fileInputRefs.current[index].value = '';
    return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSizeInBytes = 1 * 1024 * 1024; // 1 MB

    if (!allowedTypes.includes(file.type)) {
      toast.error('Invalid file type. Only PDF, JPEG, and PNG are allowed.');
      if (fileInputRefs.current[index]) fileInputRefs.current[index].value = '';
      return;
    }

    if (file.size > maxSizeInBytes) {
      toast.error('File size must be less than 1MB.');
      if (fileInputRefs.current[index]) fileInputRefs.current[index].value = '';
      return;
    }

    getBase64(file, (base64) => {
      newDocs[index]['fileName'] = base64;
      setDocuments(newDocs); // update only after base64 is ready
    });
  } else {
    newDocs[index][field] = value;
    setDocuments(newDocs);
  }
  
};



 



  useEffect(() => {
    setLoading(false)
    setLoad(true)
  }, [])

    useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.resellerType.getResellerType(null,null);

        if(response.data){
          setRegionList(response.data);
        }
        

      } catch (error) {
        // console.error("Error fetching region data:", error);
      }
    };

  
    fetchData();
    
  }, []);


  return isLoad ?  (
    <Formik
      validationSchema={Schema}
      initialValues={{
        merchentRegion: '',
        merchentType: '',
        name: '',
        address: '',
        city: '',
        pincode: '',
        state: '',
        country: '',
        contactName: '',
        mobile: '',
        email: '',
        pan: '',
        panBase64: '',
        gst: '',
        vat: '',
        adhaar: '',
        adhaarBase64: '',
        documents: [{ documentTypeId: '', fileName: null }],
        taxNumber: '',
        terms:false,
        guidline:false
      }}
      onSubmit={(values, { resetForm, setSubmitting }) => {
        
        const hasInvalidDocument = documents.some(
          (doc) => !doc.documentTypeId || !doc.fileName
        );

        if (hasInvalidDocument) {
          toast.error('Please fill all required documents before submitting.');
          setSubmitting(false);
          return;
        }

        setLoading(true)


        const taxType = values.merchentRegion === '1'
        ? 'GST'
        : values.merchentRegion === '2'
        ? 'VAT'
        : 'VAT'; 

        const data = {

          merchentType: values.merchentType,
          name: values.name,
          address: values.address,
          city: values.city,
          pincode: values.pincode,
          state: values.state.value,
          country: values.country.value,
          contactName: values.contactName,
          mobile: values.mobile,
          email: values.email,
          documents: documents,
          resellerRegionId:values.merchentRegion,
          merchenttaxNumber:values.taxNumber,
          merchenttaxType:taxType
       }

       
        api.authenticate.merchentRequest(data)
          .then(res => {
            if (res.code === 200) {
              resetForm()
              setLoading(false)
              toast.success(res.message);
            }
            else {
              toast.error(res.message);
              setLoading(false)
              setSubmitting(false);
              // resetForm();
            }
          })
          .catch(err => {
            // resetForm()
            setSubmitting(false);
            setLoading(false)
            toast.error("Oops! Something went wrong", 'error');
          })
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
        isSubmitting

      }) => {

         const termsLink =
          !values.merchentRegion || values.merchentRegion === "1"
            ? "/terms/reseller_terms_and_conditions.docx"
            : "/terms/reseller_terms_and_conditions_nodwin_mena.docx";

        return (

          <div className="container">
            <div className="register-main">
              <div className="card">
                <div className="welcome">
                  <h5>Merchant Registration Form</h5>
                  {/* <pre>{JSON.stringify(errors, null, 2)}</pre> */}
                  
                </div>

                <div className="card-body">
                  <img className="login-logo" src={LoginImage} alt="login-logo" />
                  
                  <form noValidate="" className="form-horizontal" onSubmit={handleSubmit}>
                  <div className="row regreqbox">

                  <div className="form-group col-md-12">
                  <label htmlFor="merchentRegion">Region</label>
                  <Field as="select" name="merchentRegion"  className={"form-control"}

                    onChange={async (e) => {
                    const selectedRegionId = e.target.value;

                    // Update Formik field value
                    setFieldValue("merchentRegion", selectedRegionId);

                    // Fetch document types
                    try {
                      const response = await api.resellerType.getDocumentTypesByRegionId({resellerRegionId:selectedRegionId}, null);
                      
                      if(response.success === true){
                          setDocumentOptions(response.data); 
                      }else{
                        setDocumentOptions([]); 
                      }
                
                      } catch (error) {
                        setDocumentOptions([]); 
                      }
                    }}
                   >

      
                   
                  
                  <option value="" >Select Region</option>
                    {regionList.map(regionlistdata => (
                      <option key={regionlistdata.id} value={regionlistdata.id}>
                        {regionlistdata.name} ({regionlistdata.currency})
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name="merchentRegion" component="div" className="text-danger"/>
            
                    </div>


                    {values.merchentRegion === '1' ? (

                           <RegionFormIndia
                          options={options}
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue}
                          isSubmitting={isSubmitting}
                       
                        />
  
  
                    ) : values.merchentRegion === '2' ? (

                            <RegionFormUae
                              options={options}
                              values={values}
                              touched={touched}
                              errors={errors}
                              handleChange={handleChange}
                              setFieldValue={setFieldValue}
                              isSubmitting={isSubmitting}
                             
                            />


                    ) : (

                         <RegionFormIndia
                              options={options}
                              values={values}
                              touched={touched}
                              errors={errors}
                              handleChange={handleChange}
                              setFieldValue={setFieldValue}
                              isSubmitting={isSubmitting}
                            
                            />
                    


                    )}






             

                

               

              <div className="row">
              <div className="col-md-12">
                <h6 style={{fontWeight:'bold' }}>Upload Required Documents
                  <span    style={{   fontWeight: "normal", fontSize:"12px", color: "#cf6868"}}>
                  {values.merchentRegion === '1' && ' (PAN and Adhaar Required)'}
                  {values.merchentRegion === '2' && ' (Trade License Certificate Required)'}
                  </span>
                </h6>
              </div>


        {documents.map((doc, index) => (
          <div className="form-group col-md-12 row" key={index}>
            <div className="col-md-4">
              <label>Document Type</label>
              <select
                className="form-control"
                value={doc.documentTypeId}
                onChange={(e) => handleDocumentChange(index, 'documentTypeId', e.target.value)}
                 style={{   minWidth: "100px",
                height: "35px",
                padding: "5px 15px",
                lineHeight: "18px",
                appearance: "auto", // ensures default arrow shows in most browsers
                WebkitAppearance: "auto",
                MozAppearance: "auto",}}
              >
                <option value="">Select Document</option>
                {documentOptions.map((option, idx) => (
                  <option key={idx} value={option.documentId}>{option.documentType}</option>
                ))}
              </select>

                 {errors.documents?.[index]?.documentTypeId && (
                    <small className="text-danger">{errors.documents[index].documentTypeId}</small>
                  )}
                </div>

            <div className="col-md-6">
              <label>Upload File</label>
              <input
                type="file"
                className="form-control-file  rounded"
                onChange={(e) => handleDocumentChange(index, 'file', e.target.files[0])}
                 ref={(el) => (fileInputRefs.current[index] = el)}
              />

              {errors.documents?.[index]?.file && (
                <small className="text-danger">{errors.documents[index].file}</small>
              )}

              
            </div>

              <div className="col-md-2">
            {index > 0 && (
           
              <i className="fa fa-trash" aria-hidden="true" style={{ color: "#e60b0b", marginTop:"38px"}}  onClick={() => handleRemoveDocument(index)}></i>
            )}
          </div>
         

         
                </div>
              ))}

    

        <div className="form-group col-md-12">
          {documents.length < 5 && (
          <button type="button" className="login-btn1 btn mt-3" onClick={handleAddDocument}>
             <i className="fa fa-plus" aria-hidden="true"  style={{ color: "#fff"}}></i> Add New Document
          </button>
          )}
        </div>
   


              </div>
              {/* end doc section */}

              <div className="col-md-12" style={{marginBottom:'20px',textAlign:'justify' }}>
              <p>By registering through this Merchant registration form "Online Form" You are hereby appointed and onboarded as a reseller for the Product, by NODWIN Gaming Private Limited and/or its affiliates or sister concerns. This Online Form shall be read in conjunction with the attached Reseller agreement terms and conditions "Terms and Conditions". By registering below, the Merchant acknowledges and expressly agrees to comply with the terms set forth herein and the Terms and Conditions. The Parties agree that any capitalized terms not defined in the Online Form shall have the meanings ascribed to them in the Terms and Conditions.</p>
              </div>

                    <div className="form-group col-md-12">
                    <label style={{ fontSize: '12px' }}>
                      <input
                        type="checkbox"
                        name="terms"
                        style={{ marginRight: '10px' }}
                        checked={values.terms}
                        onChange={handleChange}
                      />
                       I hereby confirm that I have read and understood the <a href={termsLink}  target="_blank"  rel="noopener noreferrer"  style={{ color:'blue' }}>Terms and Conditions</a>. I expressly state that I agree to the  Terms and Conditions and warrant to be fully compliant with the same
                    </label>
                    {touched.terms && errors.terms && (
                      <div className="text-danger">{errors.terms}</div>
                    )}
                  </div>

                  <div className="form-group col-md-12">
                    <label style={{ fontSize: '12px' }}>
                      <input
                        type="checkbox"
                        name="guidline"
                        style={{ marginRight: '10px' }}
                        checked={values.guidline}
                        onChange={handleChange}
                      />
                       I hereby confirm that I have read and understood the <a href="/terms/nodwin_gaming_logo_guidelines.pdf"  target="_blank"  style={{ color:'blue' }}>Branding Guidelines</a>. I expressly state that I agree to the Branding Guidelines and warrant to be fully compliant with the same
                    </label>
                    {touched.guidline && errors.guidline && (
                      <div className="text-danger">{errors.guidline}</div>
                    )}
                  </div>





                    </div>

                 

                    <div className="form-group login-btn">
                      <button disabled={isSubmitting} type="submit" className="login-btn1 btn mt-3 ">
                        {loading ? <Loader /> : 'Register'}
                      </button>
                    </div>
                    <div className="forgot text-center">
                      <Link to="/login">
                        <i className="bx bxs-lock"></i> Login
                    </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Formik>
  ):"";
}
